export const isLoading = state => state.admissionReducer.reducer.isLoading

export const admission = state => state.admissionReducer.reducer.admission

export const permissions = state => state.admissionReducer.reducer.permissions

export const options = state => state.admissionReducer.reducer.options

export const application = state => state.admissionReducer.reducer.application
